export const getType = (value: unknown): string => {
    return Object.prototype.toString.call(value).slice(8, -1);
};

export const isNumber = (value: unknown): value is number => {
    return getType(value) === 'Number' && !isNaN(Number(value));
};

export const isDateObject = (value: unknown) => value instanceof Date;

export const isObjectType = (value: unknown) => typeof value === 'object';

export const isNullOrUndefined = (value: unknown): value is undefined | null => value == null;

export const isPlainObject = (value: unknown) => {
    if (getType(value) !== 'Object') return false;
    return value.constructor === Object && Object.getPrototypeOf(value) === Object.prototype;
};

export const isObject = <T extends object>(value: unknown): value is T => {
    return (
        !isNullOrUndefined(value) &&
        !Array.isArray(value) &&
        isObjectType(value) &&
        !isDateObject(value)
    );
};

export const isTruthy = (value: unknown): boolean => {
    return value === true || value === 'true';
};
